import { Button } from '@zeiss/beyond-online-react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

interface CreateButtonProps {
  transX: string;
}

export const CreateButton = ({ transX }: CreateButtonProps) => {
  const { t } = useTranslation(['common']);
  const navigate = useNavigate();

  const onClick = () => navigate('new');

  return (
    <Button icon="Plus" onClick={onClick} size="m" variant="primary">
      {t('common:action.createX', {
        x: transX,
      })}
    </Button>
  );
};
